import { Component } from "@angular/core";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'unit-one-lesson-two-guide',
    templateUrl: './_guide.component.html',
    styleUrls: ['./_guide.component.css']
})
export class UnitOneLessonTwoGuideComponent {

    pageTitle: string = "Lesson Guide | Unit 1, Lesson 2 | T-Folio";
    title: string = "Lesson Guide";
    subtitle: string = "Lesson 2: Preferences";
    breadcrumbs: string = "T-Folio | Unit 1: Job Exploration Groundwork | Lesson 2: Preferences";

    doPrint(): void {
        window.print();
    }
    public constructor(private titleService: Title) {
        this.titleService.setTitle(this.pageTitle);
    }
}
